import { Crisp } from "crisp-sdk-web";
import { aplicarApresentacaoCrispAposCarregamento, registrarEventosDeApresentacaoCrisp, sincronizarApresentacaoCrisp } from './apresentacaoDoCrisp'
export { abrirChatCrisp, deveInicializarCrisp } from './apresentacaoDoCrisp'

import { FiltradorDeErros } from 'src/erros'
import { obterSecret } from 'src/typescript/servicos/bifrost/bifrost.servico'

export async function inicializarCrisp () {
    try {
        Crisp.configure(obterSecret('CRISP_WEBSITE_ID'), {
            autoload: false
        });
        registrarEventosDeApresentacaoCrisp()
    } catch (erro) {
        FiltradorDeErros.capturarErro(erro as Error)
    }
  }

  export async function atualizarUsuarioCrisp (idUsuario: string, nomeUsuario: string, emailUsuario: string, papelUsuario: string, idEmpresaUsuario: string, nomeEmpresaUsuario: string, tamanhoEmpresaUsuario: string, canal: string, modulosDisponiveis: string[], servicosDisponiveis: string[], codigoDeAtivacao: string) {

    function formatarPapelUsuario (papelUsuario: string) {
        if (papelUsuario === 'all') {
            return 'Tipo RH - Acesso a todos os locais'
        } else if (papelUsuario === 'group') {
            return 'Tipo Gestor - Acesso a alguns locais'
        } else {
          return 'Tipo Empregado - Acesso aos próprios dados'
        }
    }

    try {
        const modulosEServicos = {...modulosDisponiveis, ...servicosDisponiveis, "idEmpresaUsuario": idEmpresaUsuario, "canal": canal, "tamanhoEmpresaUsuario": tamanhoEmpresaUsuario, "codigoDeAtivacao": codigoDeAtivacao }
        Crisp.user.setEmail(emailUsuario)
        Crisp.user.setNickname(nomeUsuario)
        Crisp.user.setCompany(nomeEmpresaUsuario, {
          description: tamanhoEmpresaUsuario + " | " + canal,
          employment: {
            title: formatarPapelUsuario(papelUsuario),
            role: formatarPapelUsuario(papelUsuario)
          }
        })
        Crisp.setTokenId(idUsuario)
        Crisp.session.setData(modulosEServicos)
        Crisp.load()
        aplicarApresentacaoCrispAposCarregamento()

    } catch (erro) {
        FiltradorDeErros.capturarErro(erro as Error)
    }

  }

export async function logoutCrisp() {
  sincronizarApresentacaoCrisp(false, window.innerWidth < 1024)
  if (Crisp.isCrispInjected()) {
    Crisp.chat.hide();
    Crisp.setTokenId("");
    Crisp.session.reset();
    // Aguardar um pouco para garantir que o reset aconteceu
    await new Promise(resolve => setTimeout(resolve, 100));

    Crisp.chat.hide();
  }
}

  export function fecharChatCrisp () {
    Crisp.chat.close()
  }
